export enum EnvironmentEnum {
  STAGING = 'staging',
  LIVE = 'live'
}
